import { AxiosError } from 'axios';

import { TENANT_ERROR } from './const';

type ApiErrorBody = {
  error?: {
    code?: string;
    message?: string;
  };
};

export type ApiError = {
  status?: number;
  code?: string;
  message?: string;
};

/**
 * Pulls the parts of the error envelope from Khufu that callers actually branch on.
 *
 * The code lives at `response.data.error.code`, not `response.code` — reading the
 * shallower path silently yields `undefined`, which is why every branch that tested it
 * used to be unreachable.
 */
export const getApiError = (e: unknown): ApiError => {
  const response = (e as AxiosError<ApiErrorBody>)?.response;

  return {
    status: response?.status,
    code: response?.data?.error?.code,
    message: response?.data?.error?.message
  };
};

/**
 * A tenant error always means this build is pointed at a company Khufu does not know
 * about — a missing or misspelled `REACT_APP_TENANT_KEY`. It is a deployment fault, not
 * something the person looking at the screen can act on, so it gets its own message
 * rather than being folded into the generic failure notice.
 */
export const isTenantError = (error: ApiError) => error.code === TENANT_ERROR;

export const TENANT_ERROR_TITLE = 'CONFIGURATION ERROR';

export const TENANT_ERROR_MESSAGE =
  'This deployment is not configured for a company. Check REACT_APP_TENANT_KEY and rebuild.';
